import { handleActions } from "redux-actions";
import {
  getSelectedRangeOption,
  getDateRanges,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom,
  getRangeOptions
} from "../../../../utils/date-range-options";

import {
  SET_LOADING,
  SET_DATES,
  UPDATE_DATES,
  UPDATE_CUSTOM_RANGE,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  UPDATE_PRICING_OPTIONS,
  FETCH_VALUES,
  SET_UPDATES_LOADING,
  RESET_FILTERS
} from "./introBreakdownSagas";

export const actionCreators = {};

const initialState = {
  isLoading: true,
  initialRequest: false,
  tablesLoading: false,
  filtersDirty: false,
  datesDirty: false,
  isUpdating: false,
  currentUser: {},
  selectedRequestDates: {},
  pricingOptions: [],
  selectedPricingOptions: [],
  dataPoints: [],
  introsSoldPieChart: [],
  visitsPieChart: [],
  tableData: { data: [], colHeaders: [] },
  rangeOptions: [],
  selectedRangeOption: {}
};

function selectPricingOptions(options, selected, usePrev = false) {
  if (usePrev) {
    return options.filter((option) => {
      return selected.some((opt) => opt.id === option.id);
    });
  }
  return options.filter((option) => option.checked);
}

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      isUpdating: action.payload,
      filtersDirty: false
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptions(action.payload.endDate, state.currentUser.calendarStartDate),
      selectedRangeOption: getSelectedRangeOption(action)
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true,
      datesDirty: true
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true,
      datesDirty: true
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    [FETCH_FILTERS_SUCCESS]: (state, { payload }) => {
      let { data, usePrev } = payload;
      return {
        ...state,
        pricingOptions: data,
        selectedPricingOptions: selectPricingOptions(data, state.selectedPricingOptions, usePrev),
        datesDirty: false
      };
    },
    [RESET_FILTERS]: (state) => ({
      ...state,
      filtersDirty: false,
      datesDirty: false,
      selectedRangeOption: getSelectedRangeOption()
    }),
    [FETCH_VALUES]: (state, { payload }) => ({
      ...state,
      dataPoints: payload.dataPoints,
      introsSoldPieChart: payload.introsSoldPieChartValues,
      visitsPieChart: payload.visitsPieChartValues,
      tableData: payload.visitsTable.tableInfo
    }),
    [UPDATE_PRICING_OPTIONS]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedPricingOptions: action.payload
    })
  },
  initialState
);
